<template>
  <div class="WorkOrderManagement">
    <AppHeader>工单管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="处理状态">
            <el-select
                style="width: 150px"
                v-model="filter.handled"
                @change="onSubmit"
            >
              <el-option
                  default-first-option
                  v-for="item in workOrderHandle"
                  :key="item.id"
                  :label="item.name"
                  :value="String(item.id)"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="filter.username"
                placeholder="用户名"
                @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传时间">
            <el-date-picker
                style="width: 250px"
                v-model="filter.dateRange"
                value-format="timestamp"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <work-order-list></work-order-list>
    </AppBox>
  </div>
</template>

<script>

import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import WorkOrderList from "@/pages/WorkOrderManagement/WorkOrderList.vue";
import {mapActions, mapMutations} from "vuex";
import {WORK_ORDER_HANDLED} from "@/utils/constants";

export default {
  name: "WorkOrderManagement",
  components: {WorkOrderList, AppBox, AppHeader},
  computed: {
    workOrderHandle: function () {
      return Object.keys(WORK_ORDER_HANDLED).map((key) => {
        return {
          id: key,
          name: WORK_ORDER_HANDLED[key],
        };
      });
    },
    filter: {
      get() {
        return this.$store.state.fuzhu.workOrderListFilter;
      },
      set(value) {
        this.$store.commit("fuzhu/setData", {
          key: "workOrderListFilter",
          value,
        });
      },
    },
  },

  methods: {
    ...mapActions("fuzhu", ["getAssistWorkOrder"]),
    ...mapMutations("fuzhu", ["clearWorkOrderListFilter"]),
    async onSubmit() {
      const filters = {
        ...this.filter,
      };
      filters.dateRange = undefined;
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getAssistWorkOrder({
            ...filters,
            page: 1,
          });
        }
      });
    },
    // 重置
    async onReset() {
      await this.clearWorkOrderListFilter();
      await this.getAssistWorkOrder({page: 1});
    },
  }
};
</script>

<style lang="scss" scoped>
.WorkOrderManagement {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }

    .toolsBox {
      text-align: right;
      margin-bottom: 20px;
    }
  }
}
</style>
